<div id="todo" class="page-layout carded left-sidebar inner-scroll">

    <fuse-sidebar class="sidebar" name="notification-account-list-sidebar" position="left" lockedOpen="gt-md">
        <notification-account-list-sidebar></notification-account-list-sidebar>
    </fuse-sidebar>

    <div class="center">

        <div class="content-card" style="overflow-y: scroll;">
            <div class="mb-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
                <form class="mat-card mat-elevation-z4 p-24 mr-24" fxLayout="column" fxLayoutAlign="start"
                      fxFlex="1 0 auto" name="form" [formGroup]="form" (ngSubmit)="onSubmit()">

                    <div class="h2 mb-24">{{'Notification account data'|translate}}</div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                            <mat-label>{{'Name'|translate}}</mat-label>
                            <input matInput formControlName="name" required>
                            <mat-error>{{'Name is required!'|translate}}</mat-error>
                        </mat-form-field>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                            <mat-label>{{'Type'|translate}}</mat-label>
                            <mat-select formControlName="type" required>
                                <mat-option [value]="type.id" *ngFor="let type of types">
                                    {{type.name}}
                                </mat-option>
                            </mat-select>
                            <mat-error>{{'Type is required!'|translate}}</mat-error>
                        </mat-form-field>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                            <mat-label>{{'Sender name'|translate}}</mat-label>
                            <input matInput formControlName="senderName" required>
                            <mat-error>{{'Sender name is required!'|translate}}</mat-error>
                        </mat-form-field>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                            <mat-label>{{'Sender email'|translate}}</mat-label>
                            <input matInput formControlName="senderEmail" required>
                            <mat-error>{{'Sender email is required!'|translate}}</mat-error>
                        </mat-form-field>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                            <mat-label>{{'Sender phone'|translate}}</mat-label>
                            <input matInput formControlName="senderPhone" required>
                            <mat-error>{{'Sender phone is required!'|translate}}</mat-error>
                        </mat-form-field>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                            <mat-label>{{'API token'|translate}}</mat-label>
                            <input matInput formControlName="apiToken">
                        </mat-form-field>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                            <mat-label>{{'URL'|translate}}</mat-label>
                            <input matInput formControlName="url">
                        </mat-form-field>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                            <mat-label>{{'Port'|translate}}</mat-label>
                            <input matInput formControlName="port">
                        </mat-form-field>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                            <mat-label>{{'Username'|translate}}</mat-label>
                            <input matInput formControlName="username">
                        </mat-form-field>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                            <mat-label>{{'Password'|translate}}</mat-label>
                            <input matInput formControlName="password" [type]="hide ? 'password' : 'text'">
                            <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                        </mat-form-field>
                    </div>


                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <div fxLayout="row" fxLayoutAlign="center center">
                            <button mat-raised-button type="submit" color="accent">
                                {{'Save'|translate}}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>